module.exports = function apiTestResults(request, currentRoute) {
  return { status: currentRoute };
};
